import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FAQ } from '../constants';
import { recaptureGlass } from '../lib/glass';

export default function FAQSection() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" aria-labelledby="faq-title" className="relative py-24 sm:py-32">
      <div className="frame grid gap-12 lg:grid-cols-12 lg:gap-16">
        <div className="lg:col-span-5">
          <h2 id="faq-title" className="h-section">
            Questions, answered
          </h2>
          <p className="mt-6 text-muted max-w-[30rem]">
            Something else on your mind?{' '}
            <Link to="/contact" className="text-accent link-line">
              Ask us directly
            </Link>{' '}
            and we will reply within one business day.
          </p>
        </div>
        <ul className="border-t border-line lg:col-span-7">
          {FAQ.map((item, i) => {
            const isOpen = open === i;
            return (
              <li key={item.question} className="border-b border-line">
                <h3>
                  <button
                    type="button"
                    onClick={() => {
                      setOpen(isOpen ? -1 : i);
                      recaptureGlass(600);
                    }}
                    aria-expanded={isOpen}
                    aria-controls={`faq-${i}`}
                    className="flex w-full items-start justify-between gap-6 py-6 text-left text-lg font-semibold sm:text-xl stretch-semi"
                  >
                    {item.question}
                    <span
                      aria-hidden="true"
                      className={`relative mt-1 h-6 w-6 shrink-0 rounded-full border transition-colors duration-300 ${
                        isOpen ? 'border-accent bg-accent' : 'border-line'
                      }`}
                    >
                      <span className={`absolute left-1/2 top-1/2 h-px w-2.5 -translate-x-1/2 -translate-y-1/2 ${isOpen ? 'bg-base' : 'bg-ink'}`} />
                      <span
                        className={`absolute left-1/2 top-1/2 h-2.5 w-px -translate-x-1/2 -translate-y-1/2 transition-transform duration-300 ${
                          isOpen ? 'scale-y-0 bg-base' : 'bg-ink'
                        }`}
                      />
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      id={`faq-${i}`}
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: 'auto', opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                      className="overflow-hidden"
                    >
                      <p className="pb-7 pr-12 text-muted max-w-[60ch]">{item.answer}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
